import React, { useContext, useEffect, useState } from "react";
import { Card, Container, Typography } from "@material-ui/core";
import PageTitle from "../../../components/pageTitle/PageTitle";
import { useNavigate, useParams } from "react-router";
import { getAllEmployee, getEmployee } from "../../../services/apiservices/employee";
import { deleteUsers, saveOrUpdateUserData, updateStripeCustomerName } from "../../../services/apiservices/users";
import AuthContext from "../../../hooks/authContext";
import CommonContext from "../../../hooks/commonContext";
import confirm from "../../../components/DialogComponent/confirm";
import { generateP } from "../../../services/helpers";
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import { useMediaQuery } from "@mui/material";
import SingleSelectNew from "../../../components/SelectField/SingleSelectNew";
import { Input } from "../../../components/ui/input";
import { Button } from "../../../components/ui/button";
import { useToast } from "../../../hooks/useToast";
import MultiSelectWithCheckbox from "../../../components/SelectField/MulitpleSelectNew";
import { CommonConfirmationDialog } from "../../../components/DialogComponent/SupplyDataDialog";

const CreateAdmin = () => {
  const commonContext = useContext(CommonContext);
  const [formData, setFormData] = useState({});
  const [error, setError] = useState({});
  const [errorMessage, setErrorMessage] = useState("");
  const [emailError, setEmailError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const { adminId } = useParams();
  const [empData, setEmpData] = useState();
  const [editData, setEditData] = useState(null);
  const [companyDetails, setCompanyDetails] = useState([]);
  const auth = useContext(AuthContext);
  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width:767px)');
  const { toast } = useToast();

  const RoleOptions = [
    {label:"Sys. Admin", value:"admin"},
    {label:"Employee", value:"Employee"},
  ]

  const EmployeeRoleOptions = [
    {label: "Team Admin", value: "Admin"},
    {label: "Support", value: "Support"},
    {label: "Guest", value: "Guest"},
    {label: "Client Team", value: "Client Team"},
  ]

  const getCompanyDetails = async () => {
    await getEmployee(adminId, (res) => {
      if (res) {
        setEditData(res?.data);
        setFormData({
          firstName: res?.data?.firstName,
          lastName: res?.data?.lastName,
          email: res?.data?.email,
          phoneNumber: res?.data?.phoneNumber,
          company: res?.data?.companyId,
          role: Array.isArray(res?.data?.role) ? res.data.role : res?.data?.role || [],
          employeerole: res?.data?.employeerole,
          companyName: res?.data?.companyName
        })
      } else {
        setFormData({})
      }
    })
  }

  useEffect(() => {
    getCompanyDetails();
  }, [adminId]);


  useEffect(() => {
    getAllEmployee((res) => {
      if (res) {
        const data = res?.data?.filter((item) => item.role === "companyUser")
        const companyNames = data.map(res => ({
          value: res?.id,
          label: `${res?.firstName} ${res?.lastName}`,
          name: `${res?.firstName} ${res?.lastName}`,
          firstName: res?.firstName,
          lastName: res?.lastName,
        }));
        setCompanyDetails(companyNames)
        setEmpData(res?.data);
      } else {
        setEmpData();
      }
    });
  }, []);

  const handleInputChange = (event) => {
    const {
      target: { name, value },
    } = event;

    const finalValue = name === "email" ? value.trim() : value;

    if (name === "email") {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      const invalidSequenceRegex = /[\/]{1}|\.{2,}|\/\.|\.\/|[^a-zA-Z0-9._%+-@]/;

      let newEmailError = "";

      if (!emailRegex.test(finalValue)) {
        newEmailError = "Please enter a valid email address.";
      } else if (invalidSequenceRegex.test(finalValue)) {
        newEmailError = "Email contains invalid or unsupported characters.";
      }

      setError((prev) => ({
        ...prev,
        [name]: newEmailError,
      }));
    } else {
      if (error[name]) {
        setError((prev) => ({
          ...prev,
          [name]: "",
        }));
      }
    }

    setFormData((prev) => ({
    ...prev,
    [name]:
      name === "role"
        ? Array.isArray(value)
          ? value
          : typeof value === "string"
          ? [value]
          : []
        : finalValue,
  }));
  };

  const validFields = () => {
    const { firstName, lastName, email, phoneNumber, company } = formData;

    let errormessages = {};
    let isValid = true;

    if (!firstName || firstName.trim() === "") {
      isValid = false;
      errormessages.firstName = "First Name is Required";
    }
    if (!lastName || lastName.trim() === "") {
      isValid = false;
      errormessages.lastName = "Last Name is Required";
    }
    if (!email || email.trim() === "") {
      isValid = false;
      errormessages.email = "Email is Required";
    }
    if (!phoneNumber || phoneNumber.trim() === "") {
      isValid = false;
      errormessages.phoneNumber = "Phone Number is Required";
    }
    if (auth.userProfile.role === "superUser") {
      if (!company || company.trim() === "") {
        isValid = false;
        errormessages.company = "Company is Required";
      }
    }
    setError(errormessages);
    return isValid;
  };

  const handelSaveData = async () => {
    setErrorMessage("");
    setEmailError("");
    setPhoneError("");
    commonContext?.setLoader(true);
    if (!validFields()) {
      commonContext?.setLoader(false);
      return;
    }
    const determinedCompanyId =
      auth.userProfile.role === "superUser"
        ? formData.company
        : auth.userProfile.role === "companyUser"
          ? auth.userProfile.id
          : auth.userProfile.companyId;

    const password = generateP();
    const data = {
      firstName: formData.firstName,
      lastName: formData.lastName,
      email: formData.email,
      phoneNumber: formData.phoneNumber,
      companyId: determinedCompanyId,
      password: password,
      confirmPassword: password,
      role: "admin",
    };

    try {
      const newData = await saveOrUpdateUserData(data);

      if (newData.status === true) {
        setFormData({});
        toast?.({title: "Success", description: "Admin account has been created successfully."});
        navigate("/account/userAdmin");
      } else {
        if (newData?.field === "email") {
          setEmailError(newData.message);
        } else if (newData?.field === "phone") {
          setPhoneError(newData.message);
        }
      }
    } catch (err) {
      setErrorMessage(err.message || "Something went wrong");
    } finally {
      commonContext?.setLoader(false);
    }
  };

  const handelUpdateData = async () => {
    setErrorMessage("");
    setEmailError("");
    setPhoneError("");
    commonContext?.setLoader(true);
    if (!validFields()) {
      commonContext?.setLoader(false);
      return;
    }
    const determinedCompanyId =
      auth.userProfile.role === "superUser"
        ? formData.company
        : auth.userProfile.role === "companyUser"
          ? auth.userProfile.id
          : auth.userProfile.companyId;
    await handleConfirmEdit();
  };

  const handleConfirmEdit = async () => {
    commonContext?.setLoader(true);

    const roleChanged = editData?.role !== formData?.role;
    const EmpRoleChanged = (editData?.employeerole || formData?.employeerole) && editData?.employeerole !== formData?.employeerole;
    const shouldGeneratePassword = roleChanged || EmpRoleChanged;

    const tempPassword = shouldGeneratePassword ? generateP() : editData?.password;

    const determinedCompanyId = auth.userProfile.role === "superUser" ? formData.company : auth.userProfile.role === "companyUser" ? auth.userProfile.id : auth.userProfile.companyId;

    const data = {
      firstName: formData?.firstName,
      lastName: formData?.lastName,
      email: formData?.email,
      phoneNumber: formData?.phoneNumber,
      companyId: determinedCompanyId,
      role: formData?.role,
      employeerole: Array.isArray(formData?.role) ? formData.role.includes("Employee") ? formData.employeerole : null : formData?.role === "Employee" ? formData?.employeerole : null,
      password: tempPassword,
      confirmPassword: tempPassword,
    };

    try {
      const newData = await saveOrUpdateUserData(data, adminId);

      if (newData.status === true) {
        setFormData({});
        toast?.({
          title: "Success",
          description: "User account has been updated successfully.",
        });
        navigate("/account/userAdmin");
      } else if (newData?.field === "email") {
        setEmailError(newData.message);
      } else if (newData?.field === "phone") {
        setPhoneError(newData.message);
      }
    } catch (err) {
      setErrorMessage(err.message || "Something went wrong");
    } finally {
      commonContext?.setLoader(false);
    }
  };

  const rundeleteAdmin = async () => {
    try {
      commonContext?.setLoader(true);
      const res = await deleteUsers(adminId);
      if (res?.status === true) {
        commonContext?.setLoader(false);
        setFormData({});
        confirm("Admin is Deleted Successfully", { cancel: false }).then(() => {
          navigate("/account/userAdmin");
        });
      } else {
        commonContext?.setLoader(false);
        console.error("Failed to delete admin:", res?.error);
      }
    } catch (error) {
      commonContext?.setLoader(false);
      console.error("Unexpected error while deleting admin:", error.message || error);
    }
  };

  const onDeleteAdmin = async () => {
    await confirm(
      "Are you Sure you want to Remove this admin?"
    ).then(() => {
      rundeleteAdmin();
    }, console.log("delete!"));
  };

  const handelCancelData = () => {
      navigate("/account/userAdmin");
      setFormData({});
  }

  const filteredEmployeeRoleOptions =  Array.isArray(formData?.role) && formData?.role?.includes("Employee") && formData?.role?.length > 1 ? EmployeeRoleOptions?.filter((opt) => opt.value !== "Client Team") : EmployeeRoleOptions;


  return (
    <>
    <Container>
      <PageTitle
        pageTitle={"Create New Admin"}
        showBreadcrumb={[
          { label: "Home", to: "/" },
          { label: "Admin", to: "/account/userAdmin" },
        ]}
        BreadCrumbCurrentPageTitle={"Create Admin"}
        showLastSeen={true}
      />
      <Card className="adminCard dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] dark:border-0"> 
      <div className="sectionBox dark:bg-[#1A1F2C]">
        <div className="d-flex flex-center delete flex-space-between p-10">
          <h3 className="sectiontitle d-flex flex-center  dark:text-white">
            {typeof adminId !== "undefined" && adminId !== ""  ? 
            <PersonOutlineOutlinedIcon className="mr-10" style={{backgroundColor : "#DBEAFE", color:"rgba(37, 99, 235, 1)", borderRadius:"9999px"}}/>   : 
            <ShieldOutlinedIcon className="mr-10" style={{backgroundColor : " rgba(220, 252, 231, 1)", color:"#16A34A", borderRadius:"9999px"}}/>}
            {typeof adminId !== "undefined" && adminId !== ""
              ? "Edit"
              : "Create New System Admin"}{" "}
            - {`${editData?.firstName ? `${editData?.firstName} ${editData?.lastName}` : ""}`}{""}
          </h3>
          {typeof adminId !== "undefined" && adminId !== "" && (
            <Button
              variant="contained"
              className="flatbutton button-danger ph-15"
              onClick={onDeleteAdmin}
            >
              Delete
            </Button>
          )}
        </div>
        <div className="mt-20">
            {!isMobile && (
              <div className="d-flex flex-center w-100">
                <div className="width50">
                  <Typography variant="body" style={{ fontSize: "16px", fontWeight: "500" }} className="dark:text-white">First Name <span className="color-red"> * </span></Typography>
                  <div className="formFieldwrap mv-10 mr-25">
                    <Input
                      size="small"
                      name="firstName"
                      className="w-100 dark:bg-[#1A1F2C] dark:text-white"
                      id="firstName"
                      variant="outlined"
                      placeholder="First Name"
                      onChange={handleInputChange}
                      disabled={!(Array.isArray(auth?.userProfile?.role) ? auth.userProfile.role.includes("companyUser") : auth?.userProfile?.role === "companyUser") && editData?.role === "companyUser"}
                      value={formData?.firstName ? formData?.firstName : ""}
                    />
                    {typeof error?.firstName !== "undefined" &&
                      error?.firstName !== "" && (
                        <span className="mt-5 d-flex small error color-danger">
                          {error?.firstName}
                        </span>
                      )}
                  </div>
                </div>
                <div className="width50">
                  <Typography variant="body" style={{ fontSize: "16px", fontWeight: "500" }}  className="dark:text-white">Last Name <span className="color-red"> * </span></Typography>
                  <div className="formFieldwrap mv-20">
                    <Input
                      size="small"
                      name="lastName"
                      id="lastName"
                      className="w-100 dark:bg-[#1A1F2C] dark:text-white"
                      variant="outlined"
                      placeholder="Last Name"
                      disabled={!(Array.isArray(auth?.userProfile?.role) ? auth.userProfile.role.includes("companyUser") : auth?.userProfile?.role === "companyUser") && editData?.role === "companyUser"}
                      onChange={handleInputChange}
                      value={formData?.lastName ? formData?.lastName : ""}
                    />
                    {typeof error?.lastName !== "undefined" &&
                      error?.lastName !== "" && (
                        <span className="mt-5 d-flex small error color-danger">
                          {error?.lastName}
                        </span>
                      )}
                  </div>
                </div>
              </div>
            )}

            {isMobile && (
              <>
                <Typography variant="body" style={{ fontSize: "16px", fontWeight: "500"}} className="dark:text-white">First Name <span className="color-red"> * </span></Typography>
                <div className="formFieldwrap mv-20">
                  <Input
                    size="small"
                    name="firstName"
                    className="w-100 dark:bg-[#1A1F2C] dark:text-white"
                    id="firstName"
                    variant="outlined"
                    placeholder="First Name"
                    disabled={!(Array.isArray(auth?.userProfile?.role) ? auth.userProfile.role.includes("companyUser") : auth?.userProfile?.role === "companyUser") && editData?.role === "companyUser"}
                    onChange={handleInputChange}
                    value={formData?.firstName ? formData?.firstName : ""}
                  />
                  {typeof error?.firstName !== "undefined" &&
                    error?.firstName !== "" && (
                      <span className="mt-5 d-flex small error color-danger">
                        {error?.firstName}
                      </span>
                    )}
                </div>
                <Typography variant="body" style={{ fontSize: "16px", fontWeight: "500"}} className="dark:text-white">Last Name <span className="color-red"> * </span></Typography>
                <div className="formFieldwrap mv-20">
                  <Input
                    size="small"
                    name="lastName"
                    id="lastName"
                    className="w-100 dark:bg-[#1A1F2C] dark:text-white"
                    variant="outlined"
                    placeholder="Last Name"
                    disabled={!(Array.isArray(auth?.userProfile?.role) ? auth.userProfile.role.includes("companyUser") : auth?.userProfile?.role === "companyUser") && editData?.role === "companyUser"}
                    onChange={handleInputChange}
                    value={formData?.lastName ? formData?.lastName : ""}
                  />
                  {typeof error?.lastName !== "undefined" &&
                    error?.lastName !== "" && (
                      <span className="mt-5 d-flex small error color-danger">
                        {error?.lastName}
                      </span>
                    )}
                </div>
              </>
            )}
            <Typography variant="body" style={{ fontSize: "16px", fontWeight: "500"}} className="dark:text-white">Email <span className="color-red"> * </span></Typography>
            <div className="formFieldwrap mv-20">
              <Input
                size="small"
                name="email"
                id="email"
                className="w-100 dark:bg-[#1A1F2C] dark:text-white"
                variant="outlined"
                placeholder="email@example.com"
                disabled={!(Array.isArray(auth?.userProfile?.role) ? auth.userProfile.role.includes("companyUser") : auth?.userProfile?.role === "companyUser") && editData?.role === "companyUser"}
                onChange={handleInputChange}
                value={formData?.email ? formData?.email : ""}
              />
              {typeof error?.email !== "undefined" &&
                error?.email !== "" && (
                  <span className="mt-5 d-flex small error color-danger">
                    {error?.email}
                  </span>
                )}
              {typeof emailError !== "" && (
                  <span className="mt-5 d-flex small error color-danger">
                    {emailError}
                  </span>
                )}
            </div>
            <Typography variant="body" style={{ fontSize: "16px", fontWeight: "500"}} className="dark:text-white">Phone Number <span className="color-red"> * </span></Typography>
            <div className="formFieldwrap mv-20">
              <Input
                size="small"
                name="phoneNumber"
                id="phoneNumber"
                variant="outlined"
                className="w-100 dark:bg-[#1A1F2C] dark:text-white"
                placeholder="Phone Number"
                disabled={!(Array.isArray(auth?.userProfile?.role) ? auth.userProfile.role.includes("companyUser") : auth?.userProfile?.role === "companyUser") && editData?.role === "companyUser"}
                onChange={handleInputChange}
                value={formData?.phoneNumber ? formData?.phoneNumber : ""}
              />
              {typeof error?.phoneNumber !== "undefined" &&
                error?.phoneNumber !== "" && (
                  <span className="mt-5 d-flex small error color-danger">
                    {error?.phoneNumber}
                  </span>
                )}
                {typeof phoneError !== "" && (
                  <span className="mt-5 d-flex small error color-danger">
                    {phoneError}
                  </span>
                )}
            </div>
            {((Array.isArray(formData?.role) && (formData.role.includes("Employee") || formData.role.includes("admin"))) || formData?.role === "Employee" ||formData?.role === "admin") && (
              <>
                {typeof adminId !== "undefined" && adminId !== "" && (
                  <>
                    <Typography
                      variant="body"
                      style={{ fontSize: "16px", fontWeight: "500" }}
                      className="dark:text-white"
                    >
                      Role
                    </Typography>

                    <div className="formFieldwrap mv-20">
                      <MultiSelectWithCheckbox
                        value={Array.isArray(formData?.role) ? formData?.role : [formData?.role]?.filter(Boolean)}
                        name="role"
                        label="Role"
                        onChange={(value) => handleInputChange({  target: { name: "role", value },})}
                        contentClass="bg-white text-black border-gray-300 dark:bg-[#2c3440] dark:text-white dark:border-[#464c59]"
                        itemClass="hover:bg-gray-100 dark:hover:bg-[#3c4351]"
                        options={RoleOptions}
                        className="w-full min-h-[40px] px-3 py-2"
                      />
                      {error?.role && (
                        <span className="mt-5 d-flex small error color-danger">
                          {error.role}
                        </span>
                      )}
                    </div>
                  </>
                )}

                {((Array.isArray(formData?.role) && formData.role.includes("Employee")) || formData?.role === "Employee") && (
                  <>
                    <Typography
                      variant="body"
                      style={{ fontSize: "16px", fontWeight: "500" }}
                      className="dark:text-white"
                    >
                      Employee Role
                    </Typography>

                    <div className="formFieldwrap mv-20">
                      <SingleSelectNew
                        label="employeerole"
                        variant="outlined"
                        name="employeerole"
                        id="employeerole"
                        contentClass="bg-white text-black border-gray-300 dark:bg-[#2c3440] dark:text-white dark:border-[#464c59]"
                        itemClass="hover:bg-gray-100 dark:hover:bg-[#3c4351]"
                        placeholder="Employee Role"
                        onChange={(value) =>
                          handleInputChange({
                            target: { name: "employeerole", value },
                          })
                        }
                        value={formData?.employeerole || ""}
                        options={filteredEmployeeRoleOptions}
                      />
                      {error?.employeerole && (
                        <span className="mt-5 d-flex small error color-danger">
                          {error.employeerole}
                        </span>
                      )}
                    </div>
                  </>
                )}
              </>
            )}
            {auth.userProfile.role === "superUser" ? (
              <div className="width50 mv-25">
                <SingleSelectNew
                  label="Company *"
                  variant="outlined"
                  name="company"
                  contentClass="bg-white text-black border-gray-300 dark:bg-[#2c3440] dark:text-white dark:border-[#464c59]"
                  itemClass="hover:bg-gray-100 dark:hover:bg-[#3c4351]"
                  id="company"
                  placeholder="Company"
                  onChange={handleInputChange}
                  value={formData?.company ? formData?.company : ""}
                  options={companyDetails}
                />
                {typeof error?.company !== "undefined" &&
                  error?.company !== "" && (
                    <span className="mt-5 d-flex small error color-danger">
                      {error?.company}
                    </span>
                  )}
              </div>
            ) : null}
          </div>
          <div className="mt-25 d-flex flex-justify-flexend">
            <Button
              variant="outline"
              color="default"
              style={{ boxShadow: "none" }}
              onClick={handelCancelData}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              className="bg-[#16A34A] text-white"
              style={{ marginLeft: 10, boxShadow: "none" }}
              onClick={adminId ? handelUpdateData : handelSaveData}
            >
              {adminId ? "Update User" : "Create Admin"}
            </Button>
          </div>
        </div>
      </Card>
    </Container>
    </>
  );
}

export default CreateAdmin;